/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.medical-score-display {
  align-items: flex-start;
  justify-content: center;

  .medical-score-display-header {
    display: flex;
    align-items: center;
    @include mixins.style-as-h2;
  }

  .accent {
    margin-left: variables.$margin-xlarge;
    font-weight: bold;
  }
  .medical-score-display-description {
    margin-top: 0;
  }
}
